<div style="min-width:700px;" *ngIf="types.length > 0">
  <div style="width:98%;">
    <span> <button class="btn btn border" (click)="saveOffice()">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
    <br>
    <hr />
    <form [formGroup]="form">
      <div class="row">
        <div class="col-md-6">
          <label>
            Förkortning
          </label>
          <input id="abbreviation" type="text" class="form-control form-control-sm" formControlName="abbreviation">
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>
            Namn
          </label>
          <input id="name" type="text" class="form-control form-control-sm" formControlName="name">
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <label>
            Ämbetstyp
          </label>
          <p-select *ngIf="types.length > 0" appendTo="body" [options]="types" formControlName="officeTypeId" [style]="{'width':'100%', 'height':'40px'}" (onChange)="setType($event)"></p-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>
            Epost
          </label>
          <input id="email" type="text" class="form-control form-control-sm" formControlName="email">
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label>
            Sorteringsordning
          </label>
          <input id="sort" type="text" class="form-control form-control-sm" formControlName="sort">
        </div>
        <div class="col-md-6">
          <label>
            Aktiv
          </label>
          <mat-checkbox formControlName="isActive"></mat-checkbox>
        </div>
      </div>
    </form>
  </div>
</div>
